import { CssAnimationProps } from '@ocean/ui/dist/animations'
import { AnimatedWrapper } from './AnimatedSection.styled'

type AnimatedSectionProps = {
  children: React.ReactNode
}

const AnimatedSection: React.FC<AnimatedSectionProps & CssAnimationProps> = ({
  children,
  animationDuration,
}) => {
  return <AnimatedWrapper animationDuration={animationDuration}>{children}</AnimatedWrapper>
}

export default AnimatedSection
